import {UIPresetConfigProviderService} from './UIPresetConfigProvider/UIPresetConfigProviderService';
import {UIBalanceService} from './UIBalance/UIBalanceService';
import {UIElementsStatesService} from './UIElementsStates/UIElementsStatesService';
import {UIAutoplayOptionsService} from '@gongxigames/framework/slotV2/ui/services/UIAutoplayOptions/UIAutoplayOptionsService';
import {UIMenuService} from '@gongxigames/framework/slotV2/ui/services/UIMenu/UIMenuService';
import {UITickerService} from '@gongxigames/framework/slotV2/ui/services/UITicker/UITickerService';
import {SpinButtonService} from '@gongxigames/framework/slotV2/ui/services/SpinButton/SpinButtonService';

export const SLOT_V2_UI_SERVICES = [
    UIPresetConfigProviderService,
    UIBalanceService,
    UIElementsStatesService,
    UIAutoplayOptionsService,
    UIMenuService,
    UITickerService,
    SpinButtonService,
] as const;
